const state = () => ({
  config: null
})

export default state
